const DEC2REGEX = /^(0|[1-9]\d*)(|\.(\d|\d\d))$/; // Número positivo de a lo más 2 decimales
const INTREGEX = /^\d+$/; // Entero positivo
const DVREGEX = /^(\d|k|K)$/; // {0,1,...,9,k,K}

export class Detalle {
	constructor() {
		this.__items = [];
	}
	get items() {
		return this.__items;
	}
	set items(x) {
		throw new Error(`No se puede modificar arreglo de ítemes de detalle (${x})`);
	}
	añadirItem(x) {
		if(!(x instanceof ItemDetalle)) {
			throw new Error(`Ítem a añadir a detalle no es instancia de ItemDetalle (${x})`);
		}
		this.__items.push(x);
	}
	payload() {
		let payloadData = this.items.map((x) => { return x.payload(); });
		return payloadData;
	}
}

export class ItemDetalle {
	constructor(nombre, cantidad, precio) {
		this.nombre = nombre;
		this.cantidad = cantidad;
		this.precio = precio;
	}
	set nombre(x) {
		if(typeof x !== 'string') {
			throw new Error(`Atributo nombre no es cadena (${x})`);
		}
		this.__nombre = x;
	}
	get nombre() {
		return this.__nombre;
	}
	set cantidad(x) {
		if(typeof x !== 'number') {
			throw new Error(`Atributo cantidad no es número (${x})`);
		}
		if(!`${x}`.match(DEC2REGEX)) {
			throw new Error(`Atributo cantidad tiene más de dos decimales o es negativo (${x})`);
		}
		if(x === 0) {
			throw new Error(`Atributo cantidad es igual a 0 (${x})`);
		}
		this.__cantidad = x;
	}
	get cantidad() {
		return this.__cantidad;
	}
	set precio(x) {
		if(typeof x !== 'number') {
			throw new Error(`Atributo precio no es número (${x})`);
		}
		if(!`${x}`.match(INTREGEX)) {
			throw new Error(`Atributo precio no es entero positivo (${x})`);
		}
		this.__precio = x;
	}
	get precio() {
		return this.__precio;
	}
	set unidad(x) {
		if(typeof x !== 'string' && x !== undefined) {
			throw new Error(`Atributo unidad no es cadena o undefined (${x})`);
		}
		this.__unidad = x;
	}
	get unidad() {
		return this.__unidad;
	}
	set descuentoPorciento(x) {
		if(typeof x !== 'number' && x !== undefined) {
			throw new Error(`Atributo descuentoPorciento no es número o undefined (${x})`);
		}
		if(x === undefined) {
			this.__descuentoPorciento = x;
			return;
		}
		if(this.descuentoMonto !== undefined) {
			throw new Error(`Atributo descuentoMonto debe ser undefined para poder establecer atributo descuentoPorciento (${x})`);
		}
		if(!`${x}`.match(DEC2REGEX)) {
			throw new Error(`Atributo descuentoPorciento tiene más de dos decimales o es negativo (${x})`);
		}
		if(x === 0) {
			throw new Error(`Atributo descuentoPorciento es igual a 0 (${x})`);
		}
		if(x > 100) {
			throw new Error(`Atributo descuentoPorciento es mayor que 100 (${x})`);
		}
		this.__descuentoPorciento = x;
	}
	get descuentoPorciento() {
		return this.__descuentoPorciento;
	}
	set descuentoMonto(x) { 
		if(typeof x !== 'number' && x !== undefined) {
			throw new Error(`Atributo descuentoMonto no es número o undefined (${x})`);
		}
		if(x === undefined) {
			this.__descuentoMonto = x;
			return;
		}
		if(this.descuentoPorciento !== undefined) {
			throw new Error(`Atributo descuentoPorciento debe ser undefined para poder establecer atributo descuentoMonto (${x})`);
		}
		if(!`${x}`.match(INTREGEX)) {
			throw new Error(`Atributo descuentoMonto no es un entero positivo (${x})`);
		}
		if(x === 0) {
			throw new Error(`Atributo descuentoMonto es igual a 0 (${x})`);
		}
		this.__descuentoMonto = x;
	}
	get descuentoMonto() {
		return this.__descuentoMonto;
	}
	set montoItem(x) { 
		if(typeof x !== 'number' && x !== undefined) {
			throw new Error(`Atributo montoItem no es número o undefined (${x})`);
		}
		if(x === undefined) {
			this.__montoItem = x;
			return;
		}
		if(!`${x}`.match(INTREGEX)) {
			throw new Error(`Atributo montoItem no es un entero positivo (${x})`);
		}
		this.__montoItem = x;
	}
	get montoItem() {
		return this.__montoItem;
	}
	set descripcionItem(x) { 
		if(typeof x !== 'string' && x !== undefined) {
			throw new Error(`Atributo descripcionItem no es cadena o undefined (${x})`);
		}
		this.__descripcionItem = x;
	}
	get descripcionItem() {
		return this.__descripcionItem;
	}	set recargoPorciento(x) {
		if(typeof x !== 'number' && x !== undefined) {
			throw new Error(`Atributo recargoPorciento no es número o undefined (${x})`);
		}
		if(x === undefined) {
			this.__recargoPorciento = x;
			return;
		}
		if(this.recargoMonto !== undefined) {
			throw new Error(`Atributo recargoMonto debe ser undefined para poder establecer atributo recargoPorciento (${x})`);
		}
		if(!`${x}`.match(DEC2REGEX)) {
			throw new Error(`Atributo recargoPorciento tiene más de dos decimales o es negativo (${x})`);
		}
		if(x === 0) {
			throw new Error(`Atributo recargoPorciento es igual a 0 (${x})`);
		}
		if(x > 100) {
			throw new Error(`Atributo recargoPorciento es mayor que 100 (${x})`);
		}
		this.__recargoPorciento = x;
	}
	get recargoPorciento() {
		return this.__recargoPorciento;
	}
	set recargoMonto(x) { 
		if(typeof x !== 'number' && x !== undefined) {
			throw new Error(`Atributo recargoMonto no es número o undefined (${x})`);
		}
		if(x === undefined) {
			this.__recargoMonto = x;
			return;
		}
		if(this.recargoPorciento !== undefined) {
			throw new Error(`Atributo recargoPorciento debe ser undefined para poder establecer atributo recargoMonto (${x})`);
		}
		if(!`${x}`.match(INTREGEX)) {
			throw new Error(`Atributo recargoMonto no es un entero positivo (${x})`);
		}
		if(x === 0) {
			throw new Error(`Atributo recargoMonto es igual a 0 (${x})`);
		}
		this.__recargoMonto = x;
	}
	get recargoMonto() {
		return this.__recargoMonto;
	}
	payload() {
		let payloadData = {
      'NmbItem': this.nombre,
      'QtyItem': this.cantidad,
      'PrcItem': this.precio,
      'UnmdItem': this.unidad,
      'DescuentoPct': this.descuentoPorciento,
      'DescuentoMonto': this.descuentoMonto,
      'MontoItem': this.montoItem,
      'DscItem': this.descripcionItem,
      'RecargoPct': this.recargoPorciento,
      'RecargoMonto': this.recargoMonto,
		};
		return payloadData;
	}
	calcularMontoItem() {
		let totalItem = 0;
		let cantidad = this.cantidad;
		let precio = this.precio;
		let descuentoPorcentaje = this.descuentoPorciento;
		let descuentoMonto = this.descuentoMonto;
		let recargoPorcentaje = this.recargoPorciento;
		let recargoMonto = this.recargoMonto;
		let subtotalItem = Math.round(precio*cantidad);
		let descuento, recargo;
		
		// Calcular descuento en función del tipo de descuento elegido.
		if(descuentoMonto !== undefined) {
			descuento = descuentoMonto;
		} else if(descuentoPorcentaje !== undefined) {
			descuento = Math.round(subtotalItem*descuentoPorcentaje/100);
		} else {
			descuento = 0;
		}
		
		// Calcular totalGrupos en función del tipo de descuento elegido.
		if(recargoMonto !== undefined) {
			recargo = recargoMonto;
		} else if(recargoPorcentaje !== undefined) {
			recargo = Math.round(subtotalItem*recargoPorcentaje/100);
		} else {
			recargo = 0;
		}

		totalItem = subtotalItem - descuento + recargo;
		
		return totalItem;
	}
}

export class RUT {
	static esRutSinDv(x) {
		// Aceptar entero o cadena
		return `${x}`.match(INTREGEX);
	}
	static esDv(x) {
		// Aceptar entero o cadena
		return `${x}`.match(DVREGEX);
	}
	static dvValido(rutSinDv, dv) {
		// https://validarutchile.cl/calcular-rut-en-javascript.php
		if(!RUT.esRutSinDv(rutSinDv)) {
			throw new Error(`Validación de Dv necesita un rutSinDv entero positivo (${rutSinDv})`);
		}
		let T = Number(rutSinDv), M = 0, S = 1;
		// PRECAUCIÓN: esto iterará infinitamene si T es negativo!
		// Arriba se asegura que NO SE DARÁ EL CASO.
	  for(; T; T = Math.floor(T/10)) { 
      S = (S + T%10*(9 - M++%6))%11;
	  }
	  let dvCalculado = S ? (S-1) : 'k';
	  return `${dvCalculado}`.toLowerCase() === `${dv}`.toLowerCase();
	}
	constructor(rutSinDv, dv) {
		if(!RUT.dvValido(rutSinDv, dv)) {
			throw new Error(`Atributo dv es incorrecto para el atributo rutSinDv entregado`);
		}
		this.rutSinDv = rutSinDv;
		this.dv = dv;
	}
	set rutSinDv(x) {
		if(!RUT.esRutSinDv(x)) {
			throw new Error(`Atributo rutSinDv no es un entero positivo (${x})`);
		}
		this.__rutSinDv = `${x}`;
	}
	get rutSinDv() {
		return this.__rutSinDv;
	}
	set dv(x) {
		if(!RUT.esDv(x)) {
			throw new Error(`Atributo dv no es un dígito, o k, o K (${x})`);
		}
		this.__dv = `${x}`;
	}
	get dv() {
		return this.__dv;
	}
	set rut(x) {
		throw new Error(`Atributo computado no modificable (${x})`);
	}
	get rut() {
		return `${this.__rutSinDv}-${this.__dv}`;
	}
	payload() {
		let payloadData = this.rut;
		return payloadData;
	}
}

export class Emisor {
	constructor(rut) {
		this.rut = rut;
	}
	set rut(x) { 
		if(!(x instanceof RUT)) {
			throw new Error(`Atributo rut entregado no es instancia de RUT (${x})`);
		}
		this.__rut = x;
	}
	get rut() {
		return this.__rut;
	}
	set sucursal(x) {
		if(typeof x !== 'number' && x !== undefined) {
			throw new Error(`Atributo sucursal no es número o undefined (${x})`);
		}
		if(x === undefined) {
			this.__sucursal = x;
			return;
		}
		if(!`${x}`.match(INTREGEX)) {
			throw new Error(`Atributo sucursal no es un entero positivo (${x})`);
		}
		this.__sucursal = x;
	}
	get sucursal() {
		return this.__sucursal;
	}
	payload() {
		let payloadData = {
			'RUTEmisor': this.rut.payload(),
      'CdgSIISucur': this.sucursal,
		};
		return payloadData;
	}
}

export class Receptor {
	constructor(rut, razonSocial) {
		this.rut = rut;
		this.razonSocial = razonSocial;
	}
	set rut(x) {
		if(!(x instanceof RUT)) {
			throw new Error(`Atributo rut entregado no es instancia de RUT (${x})`);
		}
		this.__rut = x;
	}
	get rut() {
		return this.__rut;
	}
	set razonSocial(x) {
		if(typeof x !== 'string') {
			throw new Error(`Atributo razonSocial no es cadena (${x})`);
		}
		this.__razonSocial = x;
	}
	get razonSocial() {
		return this.__razonSocial;
	}
	set direccion(x) {
		if(typeof x !== 'string' && x !== undefined) {
			throw new Error(`Atributo direccion no es cadena o undefined (${x})`);
		}
		this.__direccion = x;
	}
	get direccion() {
		return this.__direccion;
	}
	set comuna(x) {
		if(typeof x !== 'string' && x !== undefined) {
			throw new Error(`Atributo comuna no es cadena o undefined (${x})`);
		}
		this.__comuna = x;
	}
	get comuna() {
		return this.__comuna;
	}
	set contacto(x) {
		// if(typeof x !== 'string' && x !== undefined) {
		// 	throw new Error(`Atributo contacto no es cadena o undefined (${x})`);
		// }
		this.__telefono = x;
	}
	get contacto() {
		return typeof this.__telefono === 'string'?
			this.__telefono.replaceAll('+', '').trim():this.__telefono; 
	}
	set email(x) {
		// if(typeof x !== 'string' || x.length > 255) {
		// 	throw new Error(`Atributo email no es cadena de 255 caracteres (${x})`);
		// }
		this.__email = x;
	}
	get email() {
		return typeof this.__email === 'string'?
			this.__email.trim():this.__email; 
	}
	payload() {
		let payloadData = {
      'RUTRecep': this.rut.payload(),
      'RznSocRecep': this.razonSocial,
      'DirRecep': this.direccion,
      'CmnaRecep': this.comuna,
			TelefonoRecep: this.contacto,
      CorreoRecep: this.email,
		};
		return payloadData;
	}
}

export class IdentificadorDocumento {
	constructor(tipoDte, medioPago) {
		this.tipoDte = tipoDte;
		this.medioPago = medioPago;
	}
	set tipoDte(x) { 
		if(typeof x !== 'number'){
			throw new Error(`Atributo tipoDte no es número (${x})`);
		}
		if(!`${x}`.match(INTREGEX)){
			throw new Error(`Atributo tipoDte no entero positivo (${x})`);
		}
		this.__tipoDte = x;
	}
	get tipoDte() { 
		return this.__tipoDte;
	}
	payload() {
		let payloadData = {
	    'TipoDTE': this.tipoDte,
	    'Folio': 1,
			MedioPago: this.medioPago,
		};
		return payloadData;
	}
}
